require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-182-custom-fields.json") })
        }
      }, "path---article-182-custom-fields");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-182-custom-fields!./.cache/json/article-182-custom-fields.json
// module id = 531
// module chunks = 231608221292675